import { render, staticRenderFns } from "./law-ad-h5-case-list.vue?vue&type=template&id=39f9e4b4&scoped=true&"
import script from "./law-ad-h5-case-list.vue?vue&type=script&lang=js&"
export * from "./law-ad-h5-case-list.vue?vue&type=script&lang=js&"
import style0 from "./law-ad-h5-case-list.vue?vue&type=style&index=0&id=39f9e4b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f9e4b4",
  null
  
)

export default component.exports